/* tslint:disable */
/* eslint-disable */
/**
 * Adyen Card Enrollment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CommitResponseDataAllOf,
    CommitResponseDataAllOfFromJSON,
    CommitResponseDataAllOfFromJSONTyped,
    CommitResponseDataAllOfToJSON,
} from './CommitResponseDataAllOf';
import {
    FailureReason,
    FailureReasonFromJSON,
    FailureReasonFromJSONTyped,
    FailureReasonToJSON,
} from './FailureReason';
import {
    PaymentStatus,
    PaymentStatusFromJSON,
    PaymentStatusFromJSONTyped,
    PaymentStatusToJSON,
} from './PaymentStatus';

/**
 * 
 * @export
 * @interface CommitResponseData
 */
export interface CommitResponseData {
    /**
     * Order ID returned from PE order API.
     * @type {string}
     * @memberof CommitResponseData
     */
    orderId: string;
    /**
     * 
     * @type {PaymentStatus}
     * @memberof CommitResponseData
     */
    status: PaymentStatus;
    /**
     * 
     * @type {FailureReason}
     * @memberof CommitResponseData
     */
    failureReason?: FailureReason;
    /**
     * After expiryTime the order can no longer be paid.
     * @type {Date}
     * @memberof CommitResponseData
     */
    expiryTime: Date;
    /**
     * Reservation ID for the commited (authorized) payment.
     * @type {string}
     * @memberof CommitResponseData
     */
    reservationId: string;
}

export function CommitResponseDataFromJSON(json: any): CommitResponseData {
    return CommitResponseDataFromJSONTyped(json, false);
}

export function CommitResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommitResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderId': json['orderId'],
        'status': PaymentStatusFromJSON(json['status']),
        'failureReason': !exists(json, 'failureReason') ? undefined : FailureReasonFromJSON(json['failureReason']),
        'expiryTime': (new Date(json['expiryTime'])),
        'reservationId': json['reservationId'],
    };
}

export function CommitResponseDataToJSON(value?: CommitResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderId': value.orderId,
        'status': PaymentStatusToJSON(value.status),
        'failureReason': FailureReasonToJSON(value.failureReason),
        'expiryTime': (value.expiryTime.toISOString()),
        'reservationId': value.reservationId,
    };
}

